import React, { useState } from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography, TextareaAutosize, Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { chatFeedbackSubmit } from '../../actions';
import { isAdminCheck } from '../../helpers';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation, useHistory } from 'react-router-dom';
import GirlIcon from '../../assets/girlIcon.png';
import BoyIcon from '../../assets/menIcon.png';
import { FeedbackPopup } from './FeedbackPopup';

export const ChatFeedback = () => {
  
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [documentDesc, setDocumentDesc] = useState("");
  const [rating, setRating] = useState();
  const [ratings, setRatings] = useState([{text: 0, label: 'Extremely Unlikely'}, {text: 1, label: ''}, {text: 2, label: ''}, {text: 3, label: ''}, {text: 4, label: ''}, {text: 5, label: ''}, {text: 6, label: ''}, {text: 7, label: ''}, {text: 8, label: ''}, {text: 9, label: ''}, {text: 10, label: 'Extremely Likely'}])
  const [popupStatus, setPopupStatus] = useState(false);

  // Read the params
  const searchParams = new URLSearchParams(location.search)
  const src = searchParams.get('src');
  const requestId = searchParams.get('requestId');

  const handleRequestDescChange = (event) => {
    setDocumentDesc(event.target.value)
  }
  
  const getTextColor = (index) => {
    if ((rating < 7) && (rating >= index)) {
      return '#FFFFFF'
    } else if ((rating < 9) && (rating >= index)) {
     return '#FFFFFF'
    } else if ((rating < 11) && (rating >= index)) {
      return '#FFFFFF'
    }
  }

  const getBgColor = (index) => {
    if ((rating < 7) && (rating >= index)) {
      return '#E02020'
    } else if ((rating < 9) && (rating >= index)) {
     return '#F7B15C'
    } else if ((rating < 11) && (rating >= index)) {
      return '#198000'
    }
  }

  const getBorderColor = (index) => {
   if ((rating != undefined) && (index <= rating)) {
       return '1px solid #FFFFFF'
    } else if (index < 7) {
      return '1px solid #E02020'
    } else if (index < 9) {
      return '1px solid #F7B15C'
    } else {
      return '1px solid #198000'
    }
  };

  const handleSubmitSurvey = async () => {
    const result = await chatFeedbackSubmit(rating, documentDesc, requestId, src);
    setPopupStatus(true)
  }

  const handleCloseSnackBar = () => {
    setPopupStatus(false)
    history.push('./')
  }

  return (   
    <> 
    <Box container="true" maxWidth='xl' className={classes.root} >
        <Box className={classes.container}>
         
          <Box className={classes.formContainer}>
            <Box className={classes.instructionsContainer}>
                
              <Grid container direction="row">
                <Grid item xs={12} sm={12} md={12}>
                  <Box mt={1} className={classes.mbPhone}>
                    <Box >
                      <Typography className={classes.paperless} style={{paddingBottom: "10px"}}>Thank You for your Feedback on Milo!
                      </Typography>
                      <img className={classes.chatIcon} src={src == "1" ? BoyIcon : GirlIcon} alt='img' />
                      <Typography className={classes.activeHrs} style={{paddingBottom: "20px", paddingTop: "15px"}}>Thanks for using Milo, our helpful chatbot, to manage your loan experience! We’re always working to make things smoother and easier for you — and your feedback helps us do just that.</Typography>
                    </Box> 
                  </Box> 
                </Grid>
              </Grid>
              <hr className={classes.line} />

              <Box className={classes.cardBody2}>
                <Box className={classes.cardContainer}>
                  <Box className={classes.imageContainer}>
                  <Typography className={classes.paragraph}>On a scale of 0–10, how well did Milo meet your expectations? 
                  </Typography>

                    {ratings.map((item, index) => <>
                        <Box className={classes.rating} style={{border: getBorderColor(index), backgroundColor: getBgColor(index)}} key={index} onClick={() => setRating(item.text)}>
                            <span key={index} className={classes.ratingText} style={{color: getTextColor(index)}} >{item.text}</span>
                        </Box>
                      </>
                    )}
                    <span className={classes.sliderLabel}>
                      <span>Didn’t like it</span>
                      <span>Loved it!</span>
                    </span>

                  <Box className={classes.textareaSection}>
                      <TextareaAutosize
                        style={{ height: '65px' }}
                        color="primary"
                        variant="outlined"
                        type="text"
                        name="comments"
                        maxLength="500"
                        onChange={(event) => handleRequestDescChange(event)}
                        value={documentDesc}
                        placeholder='Tell us more about your rating (Optional)...'
                        className={classes.textArea}
                      >
                      </TextareaAutosize>
                    </Box> 
                  </Box> 
                </Box>
              </Box>

              <Box className={classes.singleLoanFooter}>
                  <Button
                    variant='contained'
                    color='primary'
                    className={classes.btn}
                    disabled={(rating == undefined) || isAdminCheck()}
                    onClick={() => handleSubmitSurvey()}
                  > SUBMIT</Button>
              </Box>
          
            </Box>
          </Box>
        </Box>
    </Box>  
      <FeedbackPopup 
        open={popupStatus}
        handleCancelIcon={handleCloseSnackBar}
      />
     </>

  )
}